import LoadMoreComponent from '../../../../components/LoadMoreComponent';
import { getPercent } from '../../../../helpers/showDelta';
import CheckData from '../../../../components/CatchError';
import DataTable from '../../../../components/Datatable';
import { COLUMNS } from './keys';
import query from './query';
import { scrollForTable } from '../../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class GSCReportDirectoryUrls extends LoadMoreComponent {
    constructor(props) {
        super();

        this.query = query({
            offset: 0,
            last_week: props.last_week,
            prior_week: props.prior_week,
            directory: props.directory,
            subdomain: props.subdomain,
        });
        this.offsetStep = 1000;
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.url?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;
        const attr = {
            query,
            offsetStep: this.offsetStep,
            last_week: this.props.last_week,
            prior_week: this.props.prior_week,
            directory: this.props.directory,
            subdomain: this.props.subdomain,
        };

        const showLoadMoreBtn = this.state.data?.length === this.offsetStep;

        const sortFns = {
            url: (array) => array.sort((a, b) => a.url.localeCompare(b.url)),
            keywords: (array) => array.sort((a, b) => a.keywords - b.keywords),
            keywords_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getPercent(a.keywords, a.keywordsPrior) -
                        getPercent(b.keywords, b.keywordsPrior),
                ),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            clicks_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getPercent(a.clicks, a.clicksPrior) - getPercent(b.clicks, b.clicksPrior),
                ),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            impressions_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getPercent(a.impressions, a.impressionsPrior) -
                        getPercent(b.impressions, b.impressionsPrior),
                ),
            position: (array) => array.sort((a, b) => a.position - b.position),
            position_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getPercent(a.position, a.positionPrior) -
                        getPercent(b.position, b.positionPrior),
                ),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
            ctr_delta: (array) =>
                array.sort((a, b) => getPercent(a.ctr, a.ctrPrior) - getPercent(b.ctr, b.ctrPrior)),
        };

        const extraBtns = () => (
            <div className="table-header-subtitle mb-10">
                {t('search.directories_details.table.comparingWeeks', {
                    prior: this.props.prior_week,
                    last: this.props.last_week,
                })}
            </div>
        );
        return (
            <div className="card table-main rounded-main overflow-hidden">
                <div className="col-12">
                    <CheckData
                        content_id={this.props.content_id}
                        parent_id={this.props.parent_id}
                        data={this.state.allData}
                        loading={this.state.loading}
                        loadMore={this.state.loadMore}
                    >
                        <DataTable
                            nodes={this.state.allData}
                            sortFns={sortFns}
                            COLUMNS={COLUMNS(t)}
                            fileName={t('search.directories_details.table.header')}
                            defaultSortKey="clicks"
                            header={t('search.directories_details.table.header')}
                            extraBtns={extraBtns}
                            forceRun={this.forceRun}
                            searchFunction={this.searchFunction}
                            showLoadMoreBtn={showLoadMoreBtn}
                            loadMoreLoading={this.state.loadMore}
                            loadMore={() => this.loadMore(attr)}
                            additionalStyles={{
                                Table: `
                                            --data-table-library_grid-template-columns : minmax(200px, 3fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                                           ${scrollForTable}
                                        `,
                                BaseCell: ` font-family: 'Raleway';
                                                font-weight: 500;
                                                font-size: 16px;
                                                line-height: 19px;
                                                padding: 16px 10px !important;
                                                color: #0D182C;
                                            
                                            
                                                &.underline {
                                                    text-decoration: underline;
                                                };
                                                `,
                            }}
                        />
                    </CheckData>
                </div>
            </div>
        );
    }
}

export default withTranslation()(GSCReportDirectoryUrls);
